export const renderCsCategory = (category) => {
  switch (category) {
    case 1:
      return "오배송/교차배송";
    case 2:
      return "문앞미배송";
    case 3:
      return "임의배송불만";
    case 4:
      return "불만";
    case 5:
      return "분석불가";
    default:
      return "";
  }
};
